module.exports = __webpack_public_path__ + "files/8804e999c31b24dd8b6f93573499e9ac.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/PT-Sans-regular.svg
 ** module id = 864
 ** module chunks = 0
 **/